import {
  useCreateBots,
  useDelete,
  useDeleteInvite,
  useGetEligibleList,
  useGetList,
  useGetTokenAlertSummary,
  useInvalidateTokenAlertSummary,
  useInvite,
  useUpdate,
} from './useMembers'

export const members = {
  getList: useGetList,
  delete: useDelete,
  update: useUpdate,
  eligibleList: useGetEligibleList,
  invite: useInvite,
  createBots: useCreateBots,
  deleteInvite: useDeleteInvite,
  tokenAlertSummary: useGetTokenAlertSummary,
  invalidateTokenAlertSummary: useInvalidateTokenAlertSummary,
}
